import { useReducedMotion } from "@lib/prefersReducedMotion";
import gsap from "gsap";
import { ScrollTrigger } from "./lenis";

/**
 * Split [data-split] text nodes into per-letter spans and animate on scroll-in.
 * Migrated from legacy lines 2912-2948.
 */
export function initSplitText(root: ParentNode = document): void {
  const reducedMotion = useReducedMotion();

  root.querySelectorAll<HTMLElement>("[data-split]").forEach((p) => {
    const orig = p.textContent ?? "";
    p.textContent = "";
    p.style.perspective = "1200px";
    const letters: HTMLElement[] = [];

    orig.split(/(\s+)/).forEach((tok) => {
      if (!tok) return;
      if (/^\s+$/.test(tok)) {
        p.appendChild(document.createTextNode(" "));
        return;
      }
      const wrap = document.createElement("span");
      wrap.className = "word";
      [...tok].forEach((ch) => {
        const inner = document.createElement("span");
        inner.textContent = ch;
        inner.style.display = "inline-block";
        wrap.appendChild(inner);
        letters.push(inner);
      });
      p.appendChild(wrap);
    });

    if (reducedMotion) {
      gsap.set(letters, { yPercent: 0, rotateY: 0, opacity: 1 });
      return;
    }

    gsap.set(letters, {
      yPercent: -100,
      rotateY: () => gsap.utils.random(-25, 25),
      opacity: 0,
    });

    const cascade = p.hasAttribute("data-about-cascade");

    ScrollTrigger.create({
      trigger: p,
      start: "top 85%",
      once: true,
      onEnter: () => {
        gsap.to(letters, {
          yPercent: 0,
          rotateY: 0,
          opacity: 1,
          duration: cascade ? 0.95 : 0.8,
          ease: "power3.out",
          stagger: { each: cascade ? 0.012 : 0.008, from: "start" },
        });
      },
    });
  });
}
